import React, { useState } from "react";
import { Link } from "react-router-dom";
import PageTopSlider from "../components/PageTopSlider";
import ReviewsSlider from "../components/ReviewsSlider";
import ContactForm from "../components/ContactForm";
import SEO from "../components/SEO";

export const LCA_CITY_DATA = {
  aarhus: {
    cityName: "Aarhus",
    slug: "aarhus",
    seoTitle: "LCA-beregning i Aarhus – nybyggeri efter BR18 | ET Danmark",
    metaDesc:
      "Skal du bygge nyt i Aarhus-området? Vi laver LCA-beregning, energiramme og trykprøve efter BR18. Fast pris og én konsulent. Ring 42 49 95 95.",
    h1: "LCA-beregning i Aarhus – til typehuse, villaer og erhverv",
    intro:
      "I og omkring Aarhus bliver der bygget meget nyt – fra enfamiliehuse i nye udstykninger til kontor og erhverv. Alle har det til fælles, at klimaberegningen skal være i orden, før huset må tages i brug. Vi laver LCA-beregningen sammen med energirammen og trykprøven, så du har én rådgiver hele vejen.",
    localSectionTitle: "Til arkitekter og typehusfirmaer i Aarhus",
    localSectionText:
      "Arbejder du med flere projekter ad gangen, er det en fordel, at LCA'en kan regnes direkte på jeres BIM-model eller mængdeliste. Så kan vi give jer et foreløbigt resultat tidligt i projekteringen – mens det stadig er nemt at ændre et fundament eller en facadebeklædning. Vi kører fra Horsens og er typisk i Aarhus-området, når der skal trykprøves eller energimærkes.",
    faqs: [
      {
        q: "Gælder kravet også, når jeg bygger typehus gennem et typehusfirma i Aarhus?",
        a: "Ja. Kravet følger byggeriet, ikke hvem der bygger. Spørg typehusfirmaet, om LCA'en er med i kontrakten. Ellers kan vi lave den.",
      },
      {
        q: "Hvor sender jeg LCA'en hen?",
        a: "Den indsendes sammen med færdigmeldingen til Aarhus Kommune.",
      },
      {
        q: "Kan I regne på et kontor- eller lagerbyggeri i Aarhus?",
        a: "Ja – her er grænseværdien 7,5 kg CO2e/m²/år. Vi giver et tilbud ud fra projektet.",
      },
    ],
  },
  horsens: {
    cityName: "Horsens",
    slug: "horsens",
    seoTitle: "LCA-beregning i Horsens – lokal energikonsulent | ET Danmark",
    metaDesc:
      "LCA-beregning til nybyggeri i Horsens fra lokal energikonsulent på Bjerrevej. Energiramme, LCA og trykprøve samlet. Få et tilbud i dag.",
    h1: "LCA-beregning i Horsens – fra din lokale energikonsulent",
    intro:
      "ET Danmark har base på Bjerrevej i Horsens. Bygger du nyt i Horsens, Hatting, Brædstrup, Gedved eller omegnen, kan du få LCA-beregningen, energirammen og trykprøven fra en konsulent, der har kort vej til din byggeplads.",
    localSectionTitle: "Kort vej, kort svartid",
    localSectionText:
      "Når byggeriet ligger tæt på, er det nemt at kigge forbi, hvis der er spørgsmål til materialer eller byggepladsen. Det er især en fordel for byggeprocessen, som skal dokumenteres fra 1. juli 2025: Vi kan gennemgå med entreprenøren fra start, hvilke tal der skal gemmes – strøm, brændstof, transporter og affald – så den endelige LCA ikke bliver forsinket af manglende bilag.",
    faqs: [
      {
        q: "Kan jeg komme forbi med mine tegninger?",
        a: "Ja, efter aftale. Ring på 42 49 95 95.",
      },
      {
        q: "Laver I også trykprøven på mit nye hus i Horsens?",
        a: "Ja – se også vores side om trykprøvning i Horsens (/trykproevning-i-horsens).",
      },
      {
        q: "Jeg bygger en tilbygning på 80 m² – skal jeg have en LCA?",
        a: "Nej, ikke hvis det er en tilbygning under 250 m² opvarmet areal til et enfamiliehus. Men energikravene til tilbygningen gælder stadig.",
      },
    ],
  },
  vejle: {
    cityName: "Vejle",
    slug: "vejle",
    seoTitle: "LCA-beregning i Vejle – erhverv og boliger | ET Danmark",
    metaDesc:
      "LCA-beregning efter BR18 i Vejle og Trekantområdet. Til entreprenører, haller, erhverv og enfamiliehuse. Byggeprocessen med. Ring 42 49 95 95.",
    h1: "LCA-beregning i Vejle – til entreprenører, erhverv og boliger",
    intro:
      "I Vejle og resten af Trekantområdet opføres både boliger, kontorer og haller. For entreprenører har klimakravene fra 1. juli 2025 ændret hverdagen: Nu skal selve byggepladsen også dokumenteres. Vi hjælper med LCA'en – og med at få styr på byggepladsdata fra dag ét.",
    localSectionTitle: "Til entreprenører: Byggepladsen tæller nu med",
    localSectionText:
      "Byggeprocessen har sin egen grænseværdi på 1,5 kg CO2e/m²/år. Den omfatter transport af materialer og materiel, el, varme og brændstof på pladsen samt byggeaffald. Vi udleverer en enkel registreringsliste ved opstart, så jeres byggeleder ved, hvad der skal gemmes. For haller og erhverv afhænger grænseværdien af anvendelsen – fx 7,5 kg for kontor, handel og lager og 8,0 kg for øvrigt byggeri. Vi afklarer det ved tilbudsgivningen.",
    faqs: [
      {
        q: "Skal en produktionshal have en LCA?",
        a: "Der skal laves en klimaberegning. Bygninger til erhvervsmæssig industriproduktion, hvor produktionsapparatet er en integreret del af bygningen (BBR-kode 221), er dog undtaget fra grænseværdien. Landbrugets avls- og driftsbygninger er helt undtaget.",
      },
      {
        q: "Kan I lave LCA på flere sager løbende?",
        a: "Ja – kontakt os om en samarbejdsaftale.",
      },
      {
        q: "Laver I også energirammen til erhverv?",
        a: "Ja – se vores side om energirammeberegning (/energiramme).",
      },
    ],
  },
  odense: {
    cityName: "Odense",
    slug: "odense",
    seoTitle: "LCA-beregning i Odense og på Fyn | ET Danmark",
    metaDesc:
      "Bygger du nyt i Odense eller på Fyn? Få LCA-beregning, energiramme, trykprøve og energimærke fra én konsulent. Fast pris. Ring 42 49 95 95.",
    h1: "LCA-beregning i Odense og på hele Fyn",
    intro:
      "Bygger du nyt hus i Odense eller et andet sted på Fyn, skal du bruge en LCA-beregning for at få ibrugtagningstilladelse. Mange private bygherrer hører først om kravet sent i forløbet. Her får du overblikket – og én konsulent, der klarer al BR18-dokumentationen.",
    localSectionTitle: "Til dig, der bygger selv",
    localSectionText:
      "Som privat bygherre er det dig som bygningsejer, der har ansvaret for, at kravene overholdes – også hvis du bygger med flere fagentrepriser. Derfor er det en god idé at aftale LCA'en tidligt, før materialerne er bestilt. Vi kører over Lillebælt til opgaver på hele Fyn og planlægger gerne trykprøve, energimærke og LCA, så der bliver færrest mulige besøg.",
    faqs: [
      {
        q: "Skal mit nye sommerhus på Fyn have en LCA?",
        a: "Ja, fra 1. juli 2025. Grænsen er 4,0 kg CO2e/m²/år under 150 m² og 6,7 kg fra 150 m².",
      },
      {
        q: "Hvad hvis jeg bygger selv med håndværkere på hver sin entreprise?",
        a: "Så skal du selv sørge for, at byggepladsdata samles. Vi giver dig en tjekliste, som du kan sende til hver håndværker.",
      },
      {
        q: "Dækker I hele Fyn?",
        a: "Ja, hele Fyn. Ring for en konkret aftale.",
      },
    ],
  },
};

export default function CityLCA({ cityKey }) {
  const [openFaq, setOpenFaq] = useState(null);
  const data = LCA_CITY_DATA[cityKey] || LCA_CITY_DATA.aarhus;

  const otherLcaCities = Object.keys(LCA_CITY_DATA)
    .filter((k) => k !== cityKey)
    .map((k) => LCA_CITY_DATA[k]);

  return (
    <div className="bg-[#FAF9F6] text-stone-800">
      <SEO
        title={data.seoTitle}
        description={data.metaDesc}
        canonical={`https://www.etdanmark.com/lca-beregning-i-${data.slug}`}
        ogImage="https://assets.auxodev.dk/assets/769d49b2-5afc-461a-944c-d9cca711718f/dsc07546.jpg"
        faqs={data.faqs}
      />

      {/* 1. HERO */}
      <PageTopSlider
        title={`LCA-beregning i ${data.cityName}`}
        subtitle={`Lovpligtig klimaberegning efter BR18 til nybyggeri i ${data.cityName} og omegn. Samlet med energiramme, trykprøve og energimærke.`}
        badge={`BR18 Klimaberegning i ${data.cityName}`}
        breadcrumbs={[
          { label: "Forside", to: "/" },
          { label: "LCA-beregning", to: "/lca-beregning" },
          { label: data.cityName },
        ]}
        actions={
          <>
            <a
              href="#kontakt"
              className="px-6 py-3 rounded-full bg-emerald-600 hover:bg-emerald-500 text-white font-bold text-sm shadow-md transition-all flex items-center gap-2"
            >
              <i className="fa-solid fa-leaf text-xs" aria-hidden="true"></i>
              <span>Få et uforpligtende tilbud i {data.cityName}</span>
            </a>
            <a
              href="tel:+4542499595"
              className="px-6 py-3 rounded-full bg-white/15 hover:bg-white/25 border border-white/30 text-white font-bold text-sm backdrop-blur-xs transition-all flex items-center gap-2"
            >
              <i className="fa-solid fa-phone text-emerald-300 text-xs" aria-hidden="true"></i>
              <span>Ring 42 49 95 95</span>
            </a>
          </>
        }
        image={{
          url: "https://assets.auxodev.dk/assets/769d49b2-5afc-461a-944c-d9cca711718f/dsc07546.jpg",
          alt: `LCA-beregning i ${data.cityName}`,
        }}
      />

      {/* 2. H1 + UNIK INTRO */}
      <section className="py-14 bg-white border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-3xl space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-100 text-emerald-800 text-xs font-bold uppercase tracking-wider">
              <i className="fa-solid fa-location-dot" aria-hidden="true"></i>
              <span>{data.cityName} og omegn</span>
            </div>
            <h1 className="text-3xl sm:text-4xl font-extrabold text-stone-900 tracking-tight">
              {data.h1}
            </h1>
            <p className="text-stone-600 text-sm sm:text-base leading-relaxed">
              {data.intro}
            </p>
          </div>

          {/* 3. LOKALT AFSNIT */}
          <div className="mt-8 p-6 sm:p-8 rounded-3xl bg-stone-50 border border-stone-200 space-y-3 max-w-4xl">
            <h2 className="text-xl font-bold text-stone-900 tracking-tight">
              {data.localSectionTitle}
            </h2>
            <p className="text-stone-600 text-sm sm:text-base leading-relaxed">
              {data.localSectionText}
            </p>
          </div>

          {/* Krydslinks til relaterede lokale ydelser */}
          <div className="mt-8 p-4 rounded-2xl bg-emerald-50/50 border border-emerald-200/80 text-xs text-stone-700 max-w-4xl">
            <span className="font-bold text-emerald-950 block mb-2">
              Øvrige ydelser i {data.cityName}:
            </span>
            <div className="flex flex-wrap gap-4">
              <Link
                to={`/energimaerkning-i-${data.slug}`}
                className="text-emerald-800 hover:text-emerald-950 hover:underline font-semibold flex items-center gap-1.5"
              >
                <i className="fa-solid fa-certificate text-emerald-600" aria-hidden="true"></i>
                <span>Energimærkning i {data.cityName}</span>
              </Link>
              <Link
                to={`/trykproevning-i-${data.slug}`}
                className="text-emerald-800 hover:text-emerald-950 hover:underline font-semibold flex items-center gap-1.5"
              >
                <i className="fa-solid fa-wind text-emerald-600" aria-hidden="true"></i>
                <span>Trykprøvning i {data.cityName}</span>
              </Link>
              <Link
                to={`/energikonsulent-i-${data.slug}`}
                className="text-emerald-800 hover:text-emerald-950 hover:underline font-semibold flex items-center gap-1.5"
              >
                <i className="fa-solid fa-user-check text-emerald-600" aria-hidden="true"></i>
                <span>Energikonsulent i {data.cityName}</span>
              </Link>
              <Link
                to="/energiramme"
                className="text-emerald-800 hover:text-emerald-950 hover:underline font-semibold flex items-center gap-1.5"
              >
                <i className="fa-solid fa-compass-drafting text-emerald-600" aria-hidden="true"></i>
                <span>Energirammeberegning</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 4. FÆLLES BLOK: KORT OM KRAVENE */}
      <section className="py-14 sm:py-16 bg-stone-50 border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-3xl mb-8">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-stone-900 tracking-tight">
              Kort om klimakravene i BR18
            </h2>
            <p className="text-stone-600 text-sm mt-2 leading-relaxed">
              For alle byggerier, hvor der er søgt byggetilladelse fra 1. juli 2025, skal næsten alt nybyggeri både have en LCA-beregning og overholde faste grænseværdier:
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            <div className="p-5 rounded-2xl bg-white border border-stone-200 shadow-2xs space-y-2">
              <span className="text-xs font-bold text-emerald-800 uppercase tracking-wider block">
                Enfamiliehuse & rækkehuse
              </span>
              <span className="text-2xl font-extrabold text-[#165B4C] block">
                6,7 kg CO2e
              </span>
              <p className="text-xs text-stone-500">
                pr. m² pr. år for materialer, udskiftninger og energiforbrug i 50 år.
              </p>
            </div>

            <div className="p-5 rounded-2xl bg-white border border-stone-200 shadow-2xs space-y-2">
              <span className="text-xs font-bold text-emerald-800 uppercase tracking-wider block">
                Byggeprocessen (separat grænse)
              </span>
              <span className="text-2xl font-extrabold text-[#165B4C] block">
                1,5 kg CO2e
              </span>
              <p className="text-xs text-stone-500">
                pr. m² pr. år for transport, el, varme, brændstof og byggeaffald.
              </p>
            </div>

            <div className="p-5 rounded-2xl bg-white border border-stone-200 shadow-2xs space-y-2">
              <span className="text-xs font-bold text-emerald-800 uppercase tracking-wider block">
                Klar til færdigmelding
              </span>
              <span className="text-2xl font-extrabold text-[#165B4C] block">
                Kommunalt krav
              </span>
              <p className="text-xs text-stone-500">
                LCA-rapporten skal godkendes af kommunen før ibrugtagningstilladelse kan udstedes.
              </p>
            </div>
          </div>

          <p className="text-xs text-stone-600">
            Læs mere om de komplette grænseværdier, beregningsmoduler og undtagelser på vores hovedside:{" "}
            <Link to="/lca-beregning" className="text-emerald-700 font-bold hover:underline">
              LCA-beregning efter BR18 →
            </Link>
          </p>
        </div>
      </section>

      {/* 5. FÆLLES BLOK: SÅDAN FOREGÅR DET (KORT 4-TRINS VERSION) */}
      <section className="py-14 sm:py-16 bg-white border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-3xl mb-10">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-stone-900 tracking-tight">
              Sådan foregår det i {data.cityName}
            </h2>
            <p className="text-stone-600 text-sm mt-2">
              Fire enkle trin fra dine tegninger til godkendt færdigmelding.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="p-6 rounded-2xl bg-stone-50 border border-stone-200 space-y-2.5">
              <span className="w-8 h-8 rounded-full bg-[#165B4C] text-white font-extrabold text-xs flex items-center justify-center">
                1
              </span>
              <h3 className="font-bold text-stone-900 text-base">Send tegninger</h3>
              <p className="text-xs text-stone-600 leading-relaxed">
                Send os plan-, snit- og facadetegninger (PDF) eller BIM/mængdeliste samt en kort projektbeskrivelse.
              </p>
            </div>

            <div className="p-6 rounded-2xl bg-stone-50 border border-stone-200 space-y-2.5">
              <span className="w-8 h-8 rounded-full bg-[#165B4C] text-white font-extrabold text-xs flex items-center justify-center">
                2
              </span>
              <h3 className="font-bold text-stone-900 text-base">Hurtig beregning</h3>
              <p className="text-xs text-stone-600 leading-relaxed">
                Du får et foreløbigt resultat inden for 5 arbejdsdage efter komplet materiale, så du tidligt ved, om byggeriet holder.
              </p>
            </div>

            <div className="p-6 rounded-2xl bg-stone-50 border border-stone-200 space-y-2.5">
              <span className="w-8 h-8 rounded-full bg-[#165B4C] text-white font-extrabold text-xs flex items-center justify-center">
                3
              </span>
              <h3 className="font-bold text-stone-900 text-base">Byggepladsdata</h3>
              <p className="text-xs text-stone-600 leading-relaxed">
                Vi udleverer en overskuelig tjekliste til entreprenøren over el, brændstof, transport og affald.
              </p>
            </div>

            <div className="p-6 rounded-2xl bg-stone-50 border border-stone-200 space-y-2.5">
              <span className="w-8 h-8 rounded-full bg-[#165B4C] text-white font-extrabold text-xs flex items-center justify-center">
                4
              </span>
              <h3 className="font-bold text-stone-900 text-base">Endelig rapport</h3>
              <p className="text-xs text-stone-600 leading-relaxed">
                Ved afslutning opdateres beregningen til den endelige rapport, klar til indsendelse med færdigmeldingen.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 6. PRIS + PAKKE (FÆLLES PRISBLOK) */}
      <section className="py-14 sm:py-16 bg-stone-50 border-b border-stone-200/70" id="priser">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="p-8 sm:p-10 rounded-3xl bg-white border border-stone-200 shadow-sm max-w-4xl space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-100 text-emerald-800 text-xs font-bold uppercase tracking-wider">
              <i className="fa-solid fa-tag text-emerald-600" aria-hidden="true"></i>
              <span>Pris og levering</span>
            </div>
            <h2 className="text-2xl sm:text-3xl font-extrabold text-stone-900 tracking-tight">
              Faste priser på LCA-beregning
            </h2>
            <div className="p-5 rounded-2xl bg-stone-50 border border-stone-200/80 text-stone-800 text-sm sm:text-base leading-relaxed">
              <p className="font-medium">
                LCA-beregning til enfamiliehus/typehus: <strong>fra 7.500 kr. inkl. moms (6.000 kr. ekskl. moms)</strong>. Erhverv og større byggerier: pris efter tilbud. Vi leverer LCA-beregningen inden for <strong>5 arbejdsdage</strong> efter modtagelse af komplet materiale (tegninger, mængder eller BIM-model).
              </p>
              <p className="mt-3 text-xs sm:text-sm text-emerald-900 font-semibold bg-emerald-100/70 p-3 rounded-xl border border-emerald-200">
                <i className="fa-solid fa-sparkles mr-1.5 text-emerald-700" aria-hidden="true"></i>
                Bestil LCA sammen med energiramme og energimærke i vores BR18-pakke, og få 10 % rabat på den samlede pris – også hvis trykprøve lægges med i samme forløb.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 7. BY-SPECIFIKKE FAQ'ER */}
      <section className="py-14 sm:py-16 bg-white border-b border-stone-200/70" id="faq">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-8">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-stone-900 tracking-tight">
              Spørgsmål om LCA-beregning i {data.cityName}
            </h2>
            <p className="text-stone-600 text-xs sm:text-sm mt-1.5">
              Lokale svar på gængse spørgsmål om nybyggeri og klimaberegning.
            </p>
          </div>

          <div className="space-y-3">
            {data.faqs.map((item, idx) => (
              <div
                key={idx}
                className="bg-[#FAF9F6] rounded-2xl border border-stone-200 overflow-hidden shadow-2xs"
              >
                <button
                  type="button"
                  onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                  className="w-full px-6 py-4 text-left font-bold text-stone-900 flex items-center justify-between gap-4 hover:bg-stone-100/60 transition-colors"
                >
                  <span className="text-sm sm:text-base">{item.q}</span>
                  <i
                    className={`fa-solid fa-chevron-down text-xs text-stone-400 transition-transform duration-200 shrink-0 ${
                      openFaq === idx ? "rotate-180 text-[#165B4C]" : ""
                    }`}
                    aria-hidden="true"
                  ></i>
                </button>
                {openFaq === idx && (
                  <div className="px-6 pb-5 pt-1 text-xs sm:text-sm text-stone-600 leading-relaxed border-t border-stone-200/60 whitespace-pre-line">
                    {item.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ANDRE BYER FOR LCA */}
      <section className="py-12 bg-stone-100 border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">
          <h3 className="text-base font-bold text-stone-900 mb-2">
            LCA-beregning i andre udvalgte byer:
          </h3>
          <div className="flex flex-wrap justify-center gap-2 max-w-2xl mx-auto pt-1">
            {otherLcaCities.map((c) => (
              <Link
                key={c.slug}
                to={`/lca-beregning-i-${c.slug}`}
                className="px-3.5 py-1.5 rounded-xl bg-white border border-stone-300 text-xs font-semibold text-stone-700 hover:bg-emerald-50 hover:border-emerald-500 hover:text-emerald-800 transition-all shadow-2xs"
              >
                LCA-beregning i {c.cityName}
              </Link>
            ))}
            <Link
              to="/lca-beregning"
              className="px-3.5 py-1.5 rounded-xl bg-emerald-700 text-white text-xs font-semibold hover:bg-emerald-800 transition-all shadow-2xs"
            >
              Hele Jylland & Fyn
            </Link>
          </div>
        </div>
      </section>

      {/* REVIEWS */}
      <ReviewsSlider />

      {/* 8. KONTAKT FORMULAR */}
      <section id="kontakt" className="py-16 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
            <div className="lg:col-span-5 space-y-4">
              <h2 className="text-2xl sm:text-3xl font-extrabold text-stone-900 tracking-tight">
                Bestil LCA-beregning i {data.cityName}
              </h2>
              <p className="text-stone-600 text-sm leading-relaxed">
                Send os dine tegninger og projektbeskrivelse. Vi svarer inden for 24 timer med en fast pris og hurtig levering.
              </p>
              <div className="p-6 rounded-2xl bg-stone-50 border border-stone-200 space-y-3">
                <div className="flex items-center gap-3">
                  <i className="fa-solid fa-phone text-[#165B4C]" aria-hidden="true"></i>
                  <a
                    href="tel:+4542499595"
                    className="font-bold text-stone-900 hover:text-emerald-700 whitespace-nowrap"
                  >
                    42 49 95 95
                  </a>
                </div>
                <div className="flex items-center gap-3">
                  <i className="fa-solid fa-envelope text-[#165B4C]" aria-hidden="true"></i>
                  <a
                    href="mailto:info@etdanmark.com"
                    className="text-stone-700 hover:text-emerald-700 whitespace-nowrap text-sm"
                  >
                    info@etdanmark.com
                  </a>
                </div>
              </div>
            </div>

            <div className="lg:col-span-7">
              <ContactForm
                defaultService="LCA-beregning"
                title={`Få et tilbud på LCA i ${data.cityName}`}
                subtitle="Upload gerne tegninger eller skriv kort om dit byggeprojekt."
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
